import classNames from "classnames";
import React from "react";

import { HttpStatus } from "../../app/constants/HttpStatus";
import { Markdown } from "./Markdown";

import Error404Image from "./ResultError404Image.png";
import Error500Image from "./ResultError500Image.png";

const classNamePrefix = "Result";

type ResultProps = Omit<React.HTMLAttributes<HTMLDivElement>, "title"> & {
  action?: React.ReactNode;
  status?: HttpStatus.NOT_FOUND | HttpStatus.INTERNAL_SERVER_ERROR;
  text: React.ReactNode;
  title: React.ReactNode;
  titleAs?: "h1" | "h2" | "h3" | "h4" | "h5";
};

export const Result = React.forwardRef(
  (props: ResultProps, ref?: React.ForwardedRef<HTMLDivElement>) => {
    const {
      action,
      children,
      className,
      role = "alert",
      status,
      text,
      title,
      titleAs: Title = "h2",
      ...restProps
    } = props;

    const image =
      status &&
      {
        [HttpStatus.NOT_FOUND]: Error404Image,
        [HttpStatus.INTERNAL_SERVER_ERROR]: Error500Image,
      }[status];

    return (
      <div
        ref={ref}
        {...restProps}
        className={classNames(className, classNamePrefix)}
        data-image={image ? true : undefined}
        data-status={status}
        role={role}
      >
        {image && (
          <div className={`${classNamePrefix}-image`}>
            <img alt="" src={image} />
          </div>
        )}
        <div className={`${classNamePrefix}-content`}>
          <Title className={`${classNamePrefix}-title`}>
            <Markdown>{title}</Markdown>
          </Title>
          <div className={`${classNamePrefix}-text`}>
            <Markdown>{text}</Markdown>
          </div>
          {children}
        </div>
        {action && <div className={`${classNamePrefix}-action`}>{action}</div>}
      </div>
    );
  },
);
